import { AfterViewInit, Component, HostListener, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { each } from 'lodash';

import { Enums } from '../../../../../../../configs/Enums';
import { TICKETS_PATHS } from '../../../../../../tickets/tickets';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-matrix',
  templateUrl: './tickets-matrix.component.html',
  styleUrls: ['./tickets-matrix.component.scss'],
  standalone: false,
})
export class TicketsMatrixComponent implements OnInit, AfterViewInit {
  public clamp = require('text-overflow-clamp');

  public Enums = Enums;
  public moment = require('moment');
  public TICKETS_PATHS = TICKETS_PATHS;
  public dateShortFormat = Enums.dates.shortFormat;
  public currentDate = this.moment().startOf('day').format(this.dateShortFormat);

  @Input() ticketsCurrentFilter;
  @Input() ticketsPeriodFilter;
  @Input() ticketsMultipleAssign;
  @Input() tickets;
  @Input() filter;
  @Input() brigadeAssign;

  @HostListener('window:scroll.out-zone', []) // notice out-zone
  onWindowScroll() {
    const intervals = document.querySelectorAll('.intervals');

    each(intervals, (interval: HTMLElement) => {
      const intervalsWrapper: HTMLElement = interval.parentElement;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const topCoords = intervalsWrapper.getBoundingClientRect().top;

      if (scrollTop >= topCoords + scrollTop - 112) {
        interval.style.width = intervalsWrapper.offsetWidth + 'px';
        interval.classList.add('intervals--fixed');
      } else {
        interval.style.width = 'auto';
        interval.classList.remove('intervals--fixed');
      }
    });
  }

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.setEllipsis();
  }

  setEllipsis(): void {
    const self = this;
    const clamps = document.querySelectorAll('.card-content__address');

    if (clamps && clamps.length) {
      each(clamps, (clampElement) => self.clamp(clampElement, 2));
    }
  }

  changeOpenedIntervals(intervals): void {
    intervals.isOpen = !intervals.isOpen;

    if (intervals.isOpen) {
      setTimeout(() => {
        this.setEllipsis();
      });
    }
  }
}
